export const RPC_POLL_TIME = 30000;

// MY INFURA_ID, SWAP IN YOURS FROM https://infura.io/dashboard/ethereum
export const INFURA_ID = process.env.REACT_APP_INFURA_KEY ?? "460f40a260564ac4a4f4b3fffb032dad";

const ETHERSCAN_API_KEY = process.env.REACT_APP_ETHERSCAN_API_KEY;
const OPTIMISTIC_ETHERSCAN_API_KEY = process.env.OPTIMISTIC_ETHERSCAN_API_KEY;
const POLYGONSCAN_API_KEY = process.env.REACT_APP_POLYGONSCAN_API_KEY;

// BLOCKNATIVE ID FOR Notify.js:
export const BLOCKNATIVE_DAPPID = "0b58206a-f3c0-4701-a62f-73c7243e8c77";

export const ALCHEMY_KEY = "oKxs-03sij-U_N0iOlrSsZFr29-IqbuF";

export const NETWORKS = {
  mainnet: {
    name: "mainnet",
    color: "#ff8b9e",
    chainId: 1,
    rpcUrl: `https://mainnet.infura.io/v3/${INFURA_ID}`,
    blockExplorer: "https://etherscan.io/",
    etherscanEndpoint: "https://api.etherscan.io",
    apiKey: ETHERSCAN_API_KEY,
  },
  polygon: {
    name: "polygon",
    color: "#2bbdf7",
    chainId: 137,
    price: 1,
    gasPrice: 1000000000,
    rpcUrl: "https://polygon-rpc.com/",
    blockExplorer: "https://polygonscan.com/",
    etherscanEndpoint: "https://api.polygonscan.com",
    apiKey: POLYGONSCAN_API_KEY,
  },
  optimism: {
    name: "optimism",
    color: "#f01a37",
    chainId: 10,
    blockExplorer: "https://optimistic.etherscan.io/",
    rpcUrl: `https://mainnet.optimism.io`,
    etherscanEndpoint: "https://api-optimistic.etherscan.io",
    apiKey: OPTIMISTIC_ETHERSCAN_API_KEY,
  },
  arbitrum: {
    name: "arbitrum",
    color: "#28a0f0",
    chainId: 42161,
    blockExplorer: "https://arbiscan.io/",
    rpcUrl: "https://arb1.arbitrum.io/rpc",
    etherscanEndpoint: "https://api.arbiscan.io",
    apiKey: ETHERSCAN_API_KEY,
  },
  opBNB: {
    name: "opBNB",
    color: "#8e5f0d",
    chainId: 204,
    price: 1,
    blockExplorer: "ttps://gnosisscan.io/",
    rpcUrl: "https://opbnb-mainnet-rpc.bnbchain.org",
    etherscanEndpoint: "https://api.gnosisscan.io",
    apiKey: ETHERSCAN_API_KEY,
  },
  BASE: {
    name: "BASE",
    color: "#8e5f0d",
    chainId: 8453,
    price: 1,
    blockExplorer: "ttps://gnosisscan.io/",
    rpcUrl: "https://mainnet.base.org",
    etherscanEndpoint: "https://www.basescan.org",
    apiKey: ETHERSCAN_API_KEY,
  },
  SHIBARIUM: {
    name: "SHIBARIUM",
    color: "#8e5f0d",
    chainId: 109,
    price: 1,
    blockExplorer: "https://www.shibariumscan.io/",
    rpcUrl: "https://www.shibrpc.com",
    etherscanEndpoint: "https://www.shibariumscan.io/",
    apiKey: ETHERSCAN_API_KEY,
  },
};

export const NETWORK = chainId => {
  for (const n in NETWORKS) {
    if (NETWORKS[n].chainId === chainId) {
      return NETWORKS[n];
    }
  }
};
